import { useCallback, useEffect, useMemo, useSyncExternalStore } from 'react';
import { useCacheGetter } from './useCacheGetter';
const NOOP_SUBSCRIBE = () => () => {};
const UNDEFINED_SNAPSHOT = () => undefined;
function useCacheSnapshot(key, cache, skip) {
  const liveSubscribe = useCallback(onStoreChange => cache.subscribe(key, onStoreChange), [cache, key]);
  const liveGetSnapshot = useCallback(() => cache.read(key), [cache, key]);
  const subscribe = skip ? NOOP_SUBSCRIBE : liveSubscribe;
  const getSnapshot = skip ? UNDEFINED_SNAPSHOT : liveGetSnapshot;
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
const idleState = {
  loading: false,
  data: undefined,
  error: undefined
};
const loadingState = {
  loading: true,
  data: undefined,
  error: undefined
};
export const useAccessCache = (key, cache, options = {
  skip: false
}) => {
  var _options$skip;
  const snapshot = useCacheSnapshot(key, cache, (_options$skip = options.skip) !== null && _options$skip !== void 0 ? _options$skip : false);
  const get = useCacheGetter(cache);
  useEffect(() => {
    if (options.skip) {
      return;
    }
    if (snapshot === undefined) {
      void get(key)
      // error is stored in the entry, but also thrown-
      // we should not let it bubble up here.
      // TODO: make sure we are correctly logging the error
      // like we do on master.
      .catch(() => {});
    }
  }, [snapshot, options.skip, get, key]);
  return useMemo(() => {
    if (options.skip) {
      return idleState;
    }
    if ((snapshot === null || snapshot === void 0 ? void 0 : snapshot.result.status) === 'success') {
      return {
        loading: false,
        data: snapshot.result.value,
        error: undefined
      };
    } else if ((snapshot === null || snapshot === void 0 ? void 0 : snapshot.result.status) === 'error') {
      return {
        loading: false,
        data: undefined,
        error: snapshot.result.error
      };
    } else {
      return loadingState;
    }
  }, [options.skip, snapshot]);
};